import { StateLabel, OrderInfo, parseDate } from "@delibrandev/utils";

export const OrderStatusLabel = ({ state }) => state === "returned"
  ? <StateLabel state="cancelled" text="Devuelto" />
  : <StateLabel state={state} />;

// The installed shared component does not yet recognize returned orders.
export const LocalOrderInfo = ({ data = {}, size = "normal" }) => data.status !== "returned"
  ? <OrderInfo data={data.displayNumber ? { ...data, number: data.displayNumber, SalesChannel: { ...data.SalesChannel, identifier: "" } } : data} size={size} />
  : (
    <div className={`orderInfo ${size !== "normal" ? "orderInfoSmall" : ""}`}>
      <div className="orderHeaderStatus">
        <OrderStatusLabel state={data.status} />
        <div className="orderNumber">
          <div className="orderLabel">No. Pedido</div>
          <div className="orderValue">{data.displayNumber ?? `${data.SalesChannel?.identifier || ""}${data.number ?? ""}`}</div>
        </div>
      </div>
      <div className="orderInfoTime">
        <div className="orderLabel">Fecha del pedido</div>
        <div className="orderValue">{parseDate(data.createdAt)}</div>
      </div>
    </div>
  );
